import { gql } from '@apollo/client';

export const SIGNIN_MUTATION = gql`
  mutation Signin($email: String!, $password: String!) {
    signin(email: $email, password: $password) {
      token
      userId
      domainId
      username
    }
  }
`;

export const SIGNUP_MUTATION = gql`
  mutation Signup($email: String!, $password: String!, $username: String!, $domain: String!) {
    signup(email: $email, password: $password, username: $username, domain: $domain) {
      token
      userId
      domainId
      username
    }
  }
`;
